<template>
  <div v-loading="waitLoading">
    <myHeader></myHeader>
    <div class="kbxmList">
      <div>
        <div class="searchBox">
          <button
            type="button"
            :class="xmlx == 1 ? 'active' : ''"
            @click="getList(1)"
          >
            今日开标项目
          </button>
          <button
            type="button"
            :class="xmlx == 2 ? 'active' : ''"
            @click="getList(2)"
          >
            全部项目
          </button>
          <el-input
            placeholder="关键字搜索"
            v-model="searchText"
            @keyup.enter.native="searchData"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="searchData"
            ></i>
          </el-input>
        </div>
        <ul class="xmLists">
          <!-- zt 0:待开标;-1,1:正在开标;2:开标结束;3:开标中止;4:二次开标 正在开标;5:二次开标评标结束正在开标; -->
          <li
            v-for="(item, index) in xmList"
            :key="index"
            :class="{
              active:
                item.zt == -1 || item.zt == 1 || item.zt == 4 || item.zt == 5,
              wait: item.zt == 0,
              over: item.zt == 2,
              zz: item.zt == 3,
            }"
            @click="goKb(item)"
          >
            <div class="lf">
              <h3>{{ item.xmmc }}</h3>
              <p>
                标段编号<span>{{ item.bdbh }}</span
                >开标时间<span>{{ item.kbsj }}</span
                >招标流程<span>{{ item.xmdlxsz }}</span>
              </p>
            </div>
          </li>
        </ul>
        <p class="noList" v-show="flag">
          <template v-if="xmlx == 2">
            {{ noText ? "无开标项目" : "无法找到您搜索的内容" }}</template
          >
          <template v-if="xmlx == 1">{{
            noText ? "今日无开标项目" : "无法找到您搜索的内容"
          }}</template>
        </p>
        <myPage
          v-if="xmlx == 2"
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
      </div>
    </div>
  </div>
</template>
<script>
import myPage from "../components/page";
import myHeader from "../components/header";
export default {
  name: "kbxmList",
  components: {
    myPage,
    myHeader,
  },
  data() {
    return {
      xmlx: 1,
      searchText: "",
      xmList: [],
      total: 1,
      currentPage: 1,
      pageSize: 5,
      flag: false,
      noText: true,
      waitLoading: false,
    };
  },
  methods: {
    getList(xmlx) {
      localStorage.removeItem("searchObj");
      this.xmlx = xmlx;
      this.currentPage = 1;
      this.searchText = "";
      this.getData();
    },
    searchData() {
      this.currentPage = 1;
      this.getData();
    },
    getData() {
      let para = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        mc: this.searchText,
        lx: this.xmlx,
        ryjs: localStorage.getItem("role") ? localStorage.getItem("role") : "",
      };
      this.waitLoading = true;
      this.flag = false;
      this.$api
        .getkbxmList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.xmList = res.data.data.list;
            this.total = res.data.data.total;
            if (this.xmList.length == 0) {
              this.flag = true;
              if (!this.searchText) {
                this.noText = true;
              } else {
                this.noText = false;
              }
            }
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {
          this.waitLoading = false;
        });
    },
    //进入开标页面
    goKb(obj) {
      let searchObj = {
        xmlx: this.xmlx,
        currentPage: this.currentPage,
        searchText: this.searchText,
      };
      sessionStorage.setItem("searchObj", JSON.stringify(searchObj));
      if (obj.zt == "3") {
        sessionStorage.setItem("kbxmZt", "3");
      } else {
        sessionStorage.removeItem("kbxmZt");
      }
      sessionStorage.setItem("sxtLx", obj.zbcd);
      if (obj.zbxmkpfs == 7) {
        this.$router.push({
          path: "/bxxmlc",
          query: { bdId: obj.bdId, xmdl: obj.xmdl },
        });
      } else {
        sessionStorage.setItem("zbxmkpfs", obj.zbxmkpfs);
        this.$router.push({
          path: "/xmlc",
          query: { bdId: obj.bdId, xmdl: obj.xmdl },
        });
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
  },
  mounted() {
    if (sessionStorage.getItem("searchObj")) {
      let obj = JSON.parse(sessionStorage.getItem("searchObj"));
      this.xmlx = obj.xmlx;
      this.currentPage = obj.currentPage;
      this.searchText = obj.searchText;
    }
    this.getData();
  },
};
</script>
<style lang="less" scope>
.kbxmList {
  position: relative;
  height: calc(~"100% - 80px");
  background: url("../assets/images/bg.png") no-repeat center center;
  background-size: cover;
  overflow-y: auto;
  padding-bottom: 20px;
  min-width: 1240px;
  > div {
    width: 1200px;
    margin: 0 auto;
    .searchBox {
      margin: 35px 0;
      text-align: right;
      button {
        width: 250px;
        height: 60px;
        line-height: 60px;
        padding: 0;
        margin: 0 10px;
        font-size: 20px;
        color: @base-color;
        background: #fff;
      }
      button.active {
        background: @base-color;
        color: #fff;
        font-weight: bold;
      }
      .el-button--default {
        color: @base-color;
      }
      > .el-input {
        width: 300px;
        height: 38px;
        line-height: 38px;
        position: relative;
        top: 8px;
        margin-left: 10px;
        input {
          height: 38px;
          line-height: 38px;
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
        .el-icon-search:before {
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
    .xmLists {
      li {
        height: 110px;
        margin-bottom: 20px;
        background: #fff;
        border-radius: 3px;
        padding-left: 33px;
        position: relative;
        overflow: hidden;
        box-shadow: 0 4px 10px rgba(00, 00, 00, 0.2);
        cursor: pointer;
        > .lf {
          width: 1130px;
          h3 {
            font-size: 18px;
            color: #333;
            margin: 30px 0 15px 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          p {
            color: #999;
            font-size: 14px;
            span {
              color: #666;
              font-weight: bold;
              font-size: 18px;
              margin: 0 120px 0 10px;
              font-family: Arial;
            }
          }
        }
      }
      li.active {
        background: #fff url("../assets/images/active.png") no-repeat top right;
      }
      li.active:hover {
        background: #f5f0f1 url("../assets/images/active.png") no-repeat top
          right;
      }
      li.wait {
        background: #fff url("../assets/images/wait.png") no-repeat top right;
      }
      li.wait:hover {
        background: #f5f0f1 url("../assets/images/wait.png") no-repeat top right;
      }
      li.over {
        h3 {
          color: #999;
        }
        p {
          color: #ccc;
          span {
            color: #999;
          }
        }
        background: #fff url("../assets/images/over.png") no-repeat top right;
      }
      li.over:hover {
        background: #f5f0f1 url("../assets/images/over.png") no-repeat top right;
      }
      li.zz {
        background: #fff url("../assets/images/zz.png") no-repeat top right;
      }
      li.zz:hover {
        background: #f5f0f1 url("../assets/images/zz.png") no-repeat top right;
      }
    }
    .noList {
      font-size: 18px;
      color: #fff;
      text-align: center;
      padding: 100px 0;
    }
  }
  .page .lf {
    color: #fff;
  }
}
</style>